module.exports = import("https://releases.transloadit.com/uppy/v4.1.0/uppy.min.mjs");;